import BGPH1 from "../../assets/images/backgrounds/AboutUs1.png";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";

const Terms = () => {
  const location = useLocation();
  const path = location.pathname;
  return (
    <>
      <Helmet>
        <title>Terms & Conditions - Addon Broker</title>
        <meta charset="UTF-8" />
        <meta
          name="description"
          content="Terms & Conditions of Use for Addon Brokers website. By using our website, you agree to these terms and conditions."
        />
        <link rel="canonical" href={path} />
      </Helmet>

      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundColor: "#005257" }}
        ></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            {/* <li><Link to="/">Home</Link></li> */}
            <li>
              <span>Terms & Conditions</span>
            </li>
          </ul>
          <h2>Terms & Conditions</h2>
        </div>
      </section>

      <section className="about-two pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="about-two__content">
                <p
                  className="about-two__text"
                  style={{
                    marginTop: "-40px",
                    fontSize: "15px",
                    textAlign: "justify",
                    fontWeight: "bold",
                  }}
                >
                  By using this website, you agree to these Terms & Conditions.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    1. General Information Only
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  Information is general in nature and not tailored to your
                  personal circumstances. It does not constitute financial or
                  credit advice.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    2. No Guarantee of Loan Approval
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  All loan applications are subject to lender approval,
                  eligibility, and lending criteria.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    3. Intellectual Property
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  All content (text, graphics, logos, design) is owned by Addon
                  Brokers. You must not reproduce or distribute content without
                  permission.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    4. Third-Party Links
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  We are not responsible for third-party websites linked from
                  our site. Accessing them is at your own risk.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    5. Limitation of Liability
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  We do not guarantee uninterrupted access or error-free
                  operation of this website. To the extent permitted by law, we
                  are not liable for any loss or damage arising from your use of
                  the website.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    6. Privacy
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  Our Privacy Policy forms part of these Terms & Conditions.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    7. Website Use
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  You must not use this website for unlawful purposes or attempt
                  unauthorised access to its systems.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    8. Governing Law
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  These Terms are governed by the laws of Victoria, Australia.
                  Disputes will be subject to the jurisdiction of Victorian
                  courts.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    9. Amendments
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  We may update these Terms from time to time. Your continued
                  use of the website constitutes acceptance of the updated
                  terms.
                </p>

                <div className="block-title text-left mt-50">
                  <h3
                    className="block-title__title"
                    style={{ fontSize: "24px", textAlign: "justify" }}
                  >
                    10. Contact Us
                  </h3>
                </div>
                <p className="about-two__text" style={{ textAlign: "justify" }}>
                  <strong>Addon Brokers</strong>
                  <br />
                </p>
                <p
                  className="about-two__text"
                  style={{ marginTop: "7px", textAlign: "justify" }}
                >
                  Email:{" "}
                  <a href="mailto:info@addonbrokers.com.au">
                    info@addonbrokers.com.au
                  </a>
                </p>
                <p className="about-two__text" style={{marginTop: "1px", textAlign: "justify" }}>
                  Phone: <a href="tel:1300755626">1300 755 626</a>
                </p>
                <p className="about-two__text" style={{marginTop: "1px", textAlign: "justify" }}>
                  Address: 5/42-52, Thomas Street, Dandenong, VIC 3175.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
